import { mapToList } from '../../utils/transform';
import { types as actions } from '../actions';

const defaultState = {
  map: {},
  list: [],
  currentLocation: {},
  geoJson: []
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.ADDED_LOCATION: {
      let locations =
        action.location.zone.id in state.map
          ? state.map[action.location.zone.id]
          : [];
      locations.push(action.location);
      let map = {
        ...state.map,
        [action.location.zone.id]: locations
      };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.EDITED_LOCATION: {
      let locations =
        action.location.zone.id in state.map
          ? state.map[action.location.zone.id]
          : [];
      let map = {
        ...state.map,
        [action.location.zone.id]: locations.map(
          location =>
            location.id === action.location.id ? action.location : location
        )
      };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.location
      };
    case actions.SET_LOCATIONS: {
      let map = {
        ...state.map,
        [action.zoneId]: action.locations
      };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.REMOVE_LOCATION: {
      let zoneId = action.location.zone.id;
      let locations = state.map[zoneId].filter(
        location => location.id !== action.location.id
      );
      let map = {
        ...state.map,
        [zoneId]: locations
      };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.GET_AREAS:
      return {
        ...defaultState
      };
    case actions.SET_LOCATIONS_BY_SITE: {
      let locations = action.locations.reduce((map, location) => {
        let zoneId = location.zone.id;
        if (zoneId in map) {
          map[zoneId].push(location);
        } else {
          map[zoneId] = [location];
        }
        return map;
      }, {});
      return {
        ...state,
        map: locations,
        geoJson: [],
        list: action.locations
      };
    }
    case actions.SET_LOCATIONS_GEO_JSON: {
      return {
        ...state,
        geoJson: action.geoJson
      }
    }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/locations/index.js